"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EstablishJoeConnectionPayloadToJSON = exports.EstablishJoeConnectionPayloadFromJSONTyped = exports.EstablishJoeConnectionPayloadFromJSON = void 0;
function EstablishJoeConnectionPayloadFromJSON(json) {
    return EstablishJoeConnectionPayloadFromJSONTyped(json, false);
}
exports.EstablishJoeConnectionPayloadFromJSON = EstablishJoeConnectionPayloadFromJSON;
function EstablishJoeConnectionPayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'authorizationCode': json['authorizationCode'],
    };
}
exports.EstablishJoeConnectionPayloadFromJSONTyped = EstablishJoeConnectionPayloadFromJSONTyped;
function EstablishJoeConnectionPayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'authorizationCode': value.authorizationCode,
    };
}
exports.EstablishJoeConnectionPayloadToJSON = EstablishJoeConnectionPayloadToJSON;
//# sourceMappingURL=EstablishJoeConnectionPayload.js.map